"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../modules/AppModule");

var MomentProvider_1 = require("./MomentProvider");

var MomentAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(MomentAppModule, _AppModule_1$AppModul);

  function MomentAppModule() {
    _classCallCheck(this, MomentAppModule);

    return _possibleConstructorReturn(this, _getPrototypeOf(MomentAppModule).apply(this, arguments));
  }

  _createClass(MomentAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(MomentProvider_1.MomentProvider).to(MomentProvider_1.MomentProvider).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return MomentAppModule;
}(AppModule_1.AppModule);

exports.MomentAppModule = MomentAppModule;